export const ONE_HUNDRED_MS = 100;
export const HALF_SECOND_MS = 500;
